import React, { useEffect, useState } from "react";
import Table from "../Components/Table";
import Header from "../Components/Header";
import Header1 from "../Components/Header1";
import { checklist, getarticle } from "../api";
import LoadingScreen from "react-loading-screen";
import { toast } from "react-toastify";

const History = () => {
  const [getlist, setGetList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allchecklist, setAllCheckList] = useState();
  const [currentrequest, setCurrentrequest] = useState({
    c_id: "",
    exits: "",
  });

  useEffect(() => {
    let isMounted = true; // Prevent state updates if unmounted

    const getlist = async () => {
      let result = await getarticle(currentrequest);
      if (result.data && isMounted) {
        setLoading(false);
        setGetList(result.data);
      } else if (result.error) {
        toast.error(result.error.message);
      }
    };
    // Initial fetch
    getlist();
    // Auto-refresh every 10 seconds (adjust as needed)
    const interval = setInterval(() => {
      getlist();
    }, 10000);
    // Cleanup on unmount or dependency change
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [currentrequest]);

  useEffect(() => {
    setLoading(true);
    let getlist = async () => {
      let result = await checklist();
      if (result) {
        setLoading(false);
        setAllCheckList(result.data);
      } else {
        console.log(result.error);
      }
    };
    getlist();
  }, []);

  // console.log(getlist);

  return (
    <div className="w-full flex justify-center">
      <div className=" w-full flex justify-center flex-col items-center">
        {/* <section className="2xl:container w-full sticky top-0 bg-white z-10">
          <Header />
        </section> */}
        <div className="w-full bg-white flex justify-center sticky top-0 bg-white z-20 border-b-[1px] border-gray-200">
          <div className="2xl:container w-full ">
            <Header />
          </div>
        </div>
        <div className="w-full flex justify-center flex-col items-center mb-auto bg-404A52 sticky top-20 z-10">
          <section className="w-full 2xl:container">
            <Header1 />
          </section>
        </div>
        <section className="2xl:container w-full">
          <LoadingScreen
            loading={loading}
            bgColor="#f1f1f1"
            spinnerColor="#9ee5f8"
            textColor="#676767"
            // logoSrc="/logo.png"
            text="Fetching Data please wait"
          >
            <Table files={getlist} setCurrentrequest={setCurrentrequest} />
          </LoadingScreen>
        </section>
      </div>
    </div>
  );
};

export default History;
